import { Injectable } from '@angular/core';
import { findClosest } from '@fi-shared/utils';

@Injectable()
export class FiAdvancedTextPanelTableHelperService {
    getTableSelectionStartNode(sel: Selection, tableCells: NodeListOf<Element>, anchorNode: Node): Element {
        return sel.getRangeAt(0).intersectsNode(tableCells.item(0))
            ? tableCells.item(0)
            : Array.from(tableCells).find((tableCell) => {
                  return (
                      tableCell.isEqualNode(findClosest(anchorNode as HTMLElement, 'TD')) ||
                      tableCell.isEqualNode(findClosest(anchorNode as HTMLElement, 'TH'))
                  );
              });
    }

    isAnyOfAnchorOrFocusNodesTableNodes(anchorNode: Node, focusNode: Node) {
        return this.isAnchorNodeTableItem(anchorNode, focusNode) || this.isFocusNodeTableItem(anchorNode, focusNode);
    }

    isAnchorNodeTableItem(anchorNode: Node, focusNode: Node) {
        return this.getTableElementFromSelectionNode(anchorNode) && !this.getTableElementFromSelectionNode(focusNode);
    }

    isFocusNodeTableItem(anchorNode: Node, focusNode: Node) {
        return !this.getTableElementFromSelectionNode(anchorNode) && this.getTableElementFromSelectionNode(focusNode);
    }

    getTableElementFromSelectionNode(selectionNode: Node): HTMLElement {
        return findClosest(selectionNode as HTMLElement, '[fi-table-text-item]');
    }

    getSelectedCells(table: HTMLElement, selection: Selection): HTMLTableCellElement[] {
        const selectedCells: HTMLTableCellElement[] = [];

        if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);

            const tableCells = table.querySelectorAll('td, th');
            tableCells.forEach((cell: HTMLTableCellElement) => {
                if (range.intersectsNode(cell)) {
                    const cellRange = range.cloneRange();
                    cellRange.selectNodeContents(cell);
                    let startOffset = 0;
                    let endOffset = cellRange.toString().length;

                    if (range.startContainer === cell) {
                        startOffset = range.startOffset - cellRange.startOffset;
                    }

                    if (range.endContainer === cell) {
                        endOffset = range.endOffset - cellRange.startOffset;
                    }

                    const selectedText = cellRange.toString().substring(startOffset, endOffset);
                    const selectedNode = Array.from(cell.childNodes).find((node) => {
                        const nodeRange = new Range();
                        nodeRange.selectNode(node);
                        return selectedText.includes(nodeRange.toString());
                    });
                    selectedCells.push(selectedNode?.parentElement as HTMLTableCellElement);
                }
            });
        }

        return selectedCells;
    }

    selectNodesBetween(startNode: Node, endNode: Node, startOffset: number = 0, endOffset: number = 0): Selection {
        const range = document.createRange();
        range.setStart(startNode, startOffset);
        range.setEnd(endNode, endOffset);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        return sel;
    }
}
